module.exports = __webpack_public_path__ + "img/studiopro_login_dark.9a919973.png";